export default {
  submit: '提交',
  'submit.ok': '已提交',
  'submit.error': '提交失败',
  'confirm.ok': '确定',
  'confirm.cancel': '取消',

  'global.setting.title': '设置',
};
